import { create } from 'zustand';
import type { CertStatusCode } from './store';

export type AuthUser = {
    id: number;
    code: string;
    fullname: string;
    firstName: string;
    lastName: string | null;
    dateBirth: string | null;
    placeBirth: string | null;
    gender: string | null;
    status: string;
    isAdmin: boolean;
    contacts: Array<{
        type: string;
        value: string;
        isPrimary: boolean;
        isVerified: boolean;
    }>;
};

export type AuthRegistration = {
    id: number;
    email: string;
    phone: string | null;
    nik: string | null;
    fullName: string | null;
    city: string | null;
    province: string | null;
    statusCode: CertStatusCode;
    lastResultCode: string | null;
    lastResultDesc: string | null;
    certExpiredAt: string | null;
    createdAt: string;
};

type State = {
    /** true = belum pernah hit /me, false = sudah resolve */
    booting: boolean;
    isAuthenticated: boolean;
    user: AuthUser | null;
    registration: AuthRegistration | null;
};

type Actions = {
    setAuth: (user: AuthUser | null, registration: AuthRegistration | null) => void;
    clearAuth: () => void;
    markBooted: () => void;
};

export const useAuthStore = create<State & Actions>((set) => ({
    booting: true,
    isAuthenticated: false,
    user: null,
    registration: null,

    setAuth: (user, registration) =>
        set({
            booting: false,
            isAuthenticated: !!user,
            user,
            registration,
        }),

    clearAuth: () => set({ booting: false, isAuthenticated: false, user: null, registration: null }),

    markBooted: () => set({ booting: false }),
}));
